import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b6433c8e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b6433c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6433c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6433c8e')) {
      api.createRecord('b6433c8e', component.options)
    } else {
      api.reload('b6433c8e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b6433c8e&scoped=true&", function () {
      api.rerender('b6433c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_price_versions/components/UpgradeTip/index.vue"
export default component.exports